import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import "./Dialog.css";
import {useRcdEdit} from '../RcdEdit/RcdEdit';
import { regUses, randomUUID } from '../../axios_with_token';
import RcdEdit from '../RcdEdit/RcdEdit';

const Dialog = ({ isOpen, onClose, onConfirm, children, dlgTitle, clickOutsideToHide, formId, btns, refDlg}) => {
    if (!isOpen) return null;

    return createPortal(
        <div
            className="dialog-overlay" onClick={clickOutsideToHide?onClose:undefined}
            ref={refDlg} 
        >
            <div className='dialog-container'>
                <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
                    <div className="dialog-header modal-header">
                        <h2>{dlgTitle || 'Dialog Title'}</h2>
                        <button onClick={onClose}>&times;</button>
                    </div>
                    <div className="dialog-body">
                        {isOpen?children:''}
                    </div>
                    <div className="dialog-footer">
                        {(btns||[]).map((Btn, key)=><Btn key={key}></Btn>)}
                    </div>
                </div>
            </div>
        </div>,
        document.getElementById('dialog-root')
    );
};

export default Dialog;

export const useDialog = ({formId, dlgTitle:dlgTitleIn, btns:btnsIn, forms, refDlg})=>{
    const refData = useRef({
        forms: forms || {},
        onCloseOnceCache: [],
        onOpenOnceCache: [],
        onOpenCache: [],
        onCloseCache: []
    });

    const [btns, setBtns] = useState(btnsIn);
    const [dlgTitle, setDlgTitle] = useState(dlgTitleIn);

    formId = formId || `formid-${randomUUID()}`;
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const onOpenDialog = fn=>{
        refData.current.onOpenCache.push(fn);
    }
    const openDialog = (paramIn) => {
        const {fnOnCloseOnce, fnOnOpenOnce} = paramIn || {};
        if(fnOnOpenOnce){
            fnOnOpenOnce();
            // refData.current.onOpenOnceCache.push(fnOnOpenOnce);
        }
        if(fnOnCloseOnce){
            refData.current.onCloseOnceCache.push(fnOnCloseOnce);
        }
        refData.current.onOpenCache.forEach(fn=>fn());
        setIsDialogOpen(true);
        return refDlg;
    };

    const onCloseDialog = fn=>{
        refData.current.onCloseCache.push(fn);
    }
    const closeDialog = () => {
        const fnOnCloseOnce = refData.current.onCloseOnceCache.pop();
        if(fnOnCloseOnce)fnOnCloseOnce();
        refData.current.onCloseCache.forEach(fn=>fn());
        setIsDialogOpen(false);
        return refDlg;
    };

    const handleConfirm = () => {
        // Handle confirmation logic here
        closeDialog();
    };

    const dlgData = refData.current;

    const BuiltInBtns={
        cancel: ({closeDialog, key})=><button
                key={key}
                className='btn btn-warning' 
                onClick={evt=>closeDialog()}
            >Cancel</button>
    }
    return {
        formId,
        isDialogOpen,
        setIsDialogOpen,
        onOpenDialog,
        openDialog,
        onCloseDialog,
        closeDialog,
        handleConfirm,
        dlgData,

        setBtns,
        setDlgTitle,
        Dialog: ({children})=><Dialog
            refDlg = {refDlg}
            isOpen={isDialogOpen} 
            onClose={closeDialog} 
            onConfirm={handleConfirm}
            dlgTitle={dlgTitle || 'dialog'}
            formId={formId}
            // convert btns component to a component that wraps callbak params in, thus could accept key in Dialog
            btns={(btns||[]).filter(a=>a).map(
                (btnFn, idx)=>_=>(btnFn.constructor===Function?btnFn:BuiltInBtns[btnFn])({
                    formId,
                    isDialogOpen,
                    setIsDialogOpen,
                    openDialog,
                    closeDialog,
                    handleConfirm,
                    dlgData,
                    key:idx
                })
            )}
        >{isDialogOpen?children:''}</Dialog>
    };
}

export const useObjEditDialog = ({
    tblDef:__tblDef,
    rcd:__rcd,
    btns,
    inputs
})=>{
    const [_tblDef, setTblDef] = useState(__tblDef);
    const [_rcd, setRcd] = useState(__rcd);

    // [] get dlg with formid
    const {
        formId,
        isDialogOpen,
        setIsDialogOpen,
        openDialog,
        closeDialog,
        handleConfirm,
        Dialog,
        dlgData
    } = useDialog({
        dlgTitle: 'edit object',
        btns:btns||[
            ({closeDialog, key})=><button
                key={key}
                className='btn btn-warning' 
                onClick={evt=>closeDialog()}>Cancel</button>,
            ({closeDialog, formId, dlgData, key})=><button
                key={key}
                form={formId}
                // type="submit"
                type="button"
                onClick={evt=>{
                    console.log('refData:', dlgData);
                    setTimeout(_=>closeDialog(), 100);
                }}
            >OK</button>
        ]
            // Cancel: true
            // OK: <button 
            //     form={formId}
            //     type="submit"
            //     onClick={evt=>setTimeout(_=>onClose(), 100)}
            // >OK</button>,
            // Cancel: <button onClick={onClose}>Cancel</button>,
            // Confirm: <button onClick={onConfirm}>Confirm</button>
        
    });

    // dlgData.forms = {};
    return {
        // dialog interface
        formId,
        isDialogOpen,
        setIsDialogOpen,
        openDialog,
        closeDialog,
        handleConfirm,

        setTblDef,
        setRcd,
        dlgData,

        // compo,ent
        Dialog: ({tblDef, rcd})=><Dialog>
            <RcdEdit
                // tblName={tblName}
                tblDef={tblDef || _tblDef}
                rcd={rcd || _rcd}
                formId={formId}
                forms={dlgData.forms}
                inputs={inputs}
            ></RcdEdit>
        </Dialog>
    }
}

export const useRcdEditDialog = ({tblName, rcdId, onSaved, defaultRcd, dlgTitle, tpl, inputs, curValues, reset})=>{
    const refDlg = useRef();

    const {regUse, DefaultResponse} = regUses();

    const refData = useRef({
        tblName,
        rcdId,
        defaultRcd
    });
    
    const formId = `rcdeditdialogid-${randomUUID()}`;
    // const forms = {};
    const {
        data:RcdEditWithRcd,
        forms,
        invalidateRcd,
        updateRemoteRcd,

        setRcdDefault,
        getRcdDefault

    } = regUse(useRcdEdit({
        curValues,
        tblName:refData.current.tblName,
        rcdId:refData.current.rcdId,
        formId,
        // forms,
        tpl,
        inputs,
        // forms:dlgData.forms // forms should be passed in to dialog, so not necessary here
        reset
    }));

    // [] get dlg with formid
    const {
        isDialogOpen,
        setIsDialogOpen,
        openDialog,
        closeDialog,
        handleConfirm,
        Dialog,
        dlgData,
        setDlgTitle
    } = useDialog({
        dlgTitle,
        forms,
        dlgTitle: dlgTitle || 'edit',
        btns:[
            ({closeDialog})=><button onClick={evt=>closeDialog()}>Cancel</button>,
            ({closeDialog, formId, dlgData})=><button 
                form={formId}
                // type="submit"
                type="button"
                onClick={async evt=>{                    
                    const r = await updateRemoteRcd();
                    setTimeout(_=>{
                        closeDialog();
                        onSaved && onSaved(r);
                    }, 100);
                }}
            >OK</button>
        ]
    });

    const setTblName = tblName=>{
        if(refData.current){
            refData.current.tblName = tblName;
        }
    }

    const setRcdId = rcdId=>{
        if(refData.current){
            refData.current.rcdId = rcdId;
        }
    }

    // let DlgContent;
    // if (isLoading()) {
    //     DlgContent = ({})=><div>Loading...</div>;
    // }else if(hasError()) {
    //     DlgContent = ({})=><div>[RcdEditDialog] Error: {getErrMsgs().map(((errMsg, errMsgIdx)=><h3 key={`${errMsgIdx}`}>{errMsg}</h3>))}</div>;
    // }else{
    //     DlgContent = ({})=><RcdEditWithRcd></RcdEditWithRcd>
    // }

    return {
        // dialog interface
        formId,
        isDialogOpen,
        setIsDialogOpen,
        openDialog,
        closeDialog,
        handleConfirm,

        // rcdedit interface
        setTblName,
        setRcdId,
        setRcdDefault,
        getRcdDefault,

        invalidateRcd,
        updateRemoteRcd,

        // compo,ent
        Dialog: ({tblName, rcdId})=><Dialog
            refDlg = {refDlg}
        >
            <DefaultResponse>
                <RcdEditWithRcd></RcdEditWithRcd>
            </DefaultResponse>
        </Dialog>,
        setDlgTitle,

        refDlg,
        forms
    }
}